import React from 'react'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  root: {
    borderTop: `1px solid ${theme.borderColor}`,
  },
}))

const PanelFooter = ({ children, className = '' }) => {
  const classes = useStyles()
  return (
    <footer className={`${classes.root} ${className}`}>
      {children}
    </footer>
  )
}

PanelFooter.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}

export default PanelFooter
